import {Organization} from 'app_api/me/types';
import {ProjectMemberResponse} from 'apps/settings/src/api/project-types';
import {
  DetailedUser,
  DomainGetResponse,
  ProjectRolesPayload,
  RoleDescriptor,
  Team,
} from 'common/report/queries/app-api/legacy/org-types';
import {ExpiresUnit} from 'common/types/reports/service-accounts';

export enum Tab {
  Project = `project`,
  Org = `org`,
  Team = `team`,
  Bulk = `bulk`,
}

export type ServiceAccountExpiry = {
  interval: number;
  unit: ExpiresUnit;
};

export type UserRow = {
  id: number;
  name?: string;
  nameError?: boolean;
  email: string;
  orgRole: string;
  projectIds: number[];
  projectRole: string;
  teamNames: string[];
  orgRoleError: boolean;
  projectError: boolean;
  projectRoleError: boolean;
  emailError: boolean;
  emailErrorMsg: string;
  emailInfo: boolean;
  projectIdsToDowngrade: number[];
  seeAll: boolean;
  error: string;
  expires?: ServiceAccountExpiry;
  nameErrorMsg?: string;
};

export type PartialProject = {
  name: string;
  id: number;
};

export type InviteUsersModalState = {
  error?: string;
  isLoading: boolean;
  isOrgProjectsProp: boolean;
  orgProjects: PartialProject[];
  org: Organization;

  serviceAccount: TODO;
  userFile: TODO;
  userRows: UserRow[];

  orgDomains: DomainGetResponse[];
  projectRoles: ProjectRolesPayload;
  orgTeams: Team[];
  orgUsers: DetailedUser[];
  project: PartialProject;
  orgRoles: RoleDescriptor[];
  projectMembers: ProjectMemberResponse;
};

export enum UserType {
  User = `user`,
  ServiceAccount = `serviceaccount`,
}

export type InviteUsersModalAttrsSchema = {
  open?: boolean;
  'exclude-teams'?: boolean;
  'user-type'?: UserType;
  type: Tab;
};

export type InviteUsersModalJsxProps = {
  attrs?: InviteUsersModalAttrsSchema;
  props?: {
    orgUsers?: DetailedUser[];
    orgProjects?: PartialProject[];
  };
  on?: TODO;
};
